import { useTheme } from 'styled-components';

export const StatementsIcon: React.FC<{ className?: string }> = ({ className }) => {
  const theme = useTheme();
  return (
    <svg
      width="18"
      height="22"
      viewBox="0 0 18 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M16.8754 0H1.12546C0.506795 0 0 0.505961 0 1.12463V20.2484C0 20.8671 0.506795 21.373 1.12546 21.373H16.8745C17.4932 21.373 18 20.8662 18 20.2484V1.12463C18 0.505961 17.494 0 16.8754 0L16.8754 0ZM16.3127 19.6864H1.68827V1.68725H16.3127V19.6864Z"
        fill={theme.iceBlue}
      />
      <path d="M4.27539 4.72455H13.725V5.84917H4.27539V4.72455Z" fill={theme.iceBlue} />
      <path d="M12.1509 8.32422H13.7255V9.44968H12.1509V8.32422Z" fill={theme.iceBlue} />
      <path d="M12.1509 11.9244H13.7255V13.0499H12.1509V11.9244Z" fill={theme.iceBlue} />
      <path d="M12.1509 15.5247H13.7255V16.6493H12.1509V15.5247Z" fill={theme.iceBlue} />
      <path d="M4.27539 8.32422H11.0248V9.44968H4.27539V8.32422Z" fill={theme.iceBlue} />
      <path d="M4.27539 11.9244H11.0248V13.0499H4.27539V11.9244Z" fill={theme.iceBlue} />
      <path d="M4.27539 15.5247H11.0248V16.6493H4.27539V15.5247Z" fill={theme.iceBlue} />
    </svg>
  );
};
